"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Phone, Mail, MapPin, Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-border/50 animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/HomePage" className="text-sm text-muted-foreground hover:text-primary transition-colors">
            Home
          </Link>
        </li>
        <li data-index={1}>
          <Link to="/OurStoryPage" className="text-sm text-muted-foreground hover:text-primary transition-colors">
            Our Story
          </Link>
        </li>
        <li data-index={2}>
          <Link to="/PortfolioPage" className="text-sm text-muted-foreground hover:text-primary transition-colors">
            The Portfolio
          </Link>
        </li>
        <li data-index={3}>
          <Link to="/LetsTalkPage" className="text-sm text-muted-foreground hover:text-primary transition-colors">
            Let's Talk
          </Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-primary transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Instagram,
    label: "Instagram",
    href: "#"
  }, {
    icon: Twitter,
    label: "Pinterest",
    href: "#"
  }, {
    icon: Linkedin,
    label: "LinkedIn",
    href: "#"
  }];
  return <section data-section-id="264782" id="footer" className="bg-muted pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/" className="inline-block w-fit">
              <WvcLogo className="h-8 w-auto text-primary" />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs font-default">
              Crafting ethereal atmospheres and signature moments for life's most exquisite celebrations.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground text-lg mb-6 tracking-widest uppercase">
              Navigation
            </h3>
            <MenuProvider menu_id="47">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground text-lg mb-6 tracking-widest uppercase">
              The Studio
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-muted-foreground font-default">
                <Phone className="size-4 mt-0.5 shrink-0 text-border" />
                <span>+1 (555) 888-9900</span>
              </li>
              <li className="flex items-start gap-3 text-sm text-muted-foreground font-default">
                <Mail className="size-4 mt-0.5 shrink-0 text-border" />
                <span>concierge@so.com</span>
              </li>
              <li className="flex items-start gap-3 text-sm text-muted-foreground font-default">
                <MapPin className="size-4 mt-0.5 shrink-0 text-border" />
                <span>450 Lavender Lane, Beverly Hills, CA</span>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground text-lg mb-6 tracking-widest uppercase">
              Social Presence
            </h3>
            <div className="flex flex-wrap gap-2">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Button key={i} data-index={i} variant="outline" size="icon" asChild className="bg-background/50 border-border/50 hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-500 rounded-lg shadow-sm">
                    <Link to={social.href} aria-label={social.label}>
                      <Icon className="size-4 stroke-[1px]" />
                    </Link>
                  </Button>;
            })}
            </div>
          </div>

        </div>

        <Separator className="my-10 bg-border/40" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground font-default">
          <p>
            &copy; {currentYear} Signature Occasions. The Art of the Atmosphere.
          </p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </section>;
}